/**
 * Report-card chalkboard geometry, measured from Canva "VRC SITE AND APP" page 13
 * (board element 365.6 x 258 px). Every value is a fraction of the board so the
 * board can grow to fill its column and still match the mock.
 */

/** Board width / height on page 13. */
export const CHALKBOARD_ASPECT = 365.6 / 258;

/** Wood frame thickness as a fraction of board width (frame is ~3.4% of the art). */
export const CHALKBOARD_FRAME_RATIO = 0.034;

/** Pixels of frame in chalkboard.webp (1200 x 746), top / right / bottom / left, for the 9-slice. */
export const CHALKBOARD_FRAME_SLICE = [40, 42, 46, 42];

export const CHALKBOARD_COLORS = {
  title: '#f9c89a',
  grade: '#faf7e0',
};

/** Trimmed chalk-stick.webp is 360 x 137. */
export const CHALK_ASPECT = 360 / 137;

export function reportCardLabel(count) {
  const n = Math.max(0, Math.floor(Number(count) || 0));
  return `${n} Report Card${n === 1 ? '' : 's'}`;
}

/**
 * Sizes and positions for a board of the given pixel size.
 * Text sizes follow board width, but are capped by height so a tall, narrow column
 * cannot push the grade into the frame.
 */
export function chalkboardLayout(width, height) {
  const w = Math.max(0, Number(width) || 0);
  const h = Math.max(0, Number(height) || 0);
  // Size type against the board as Canva drew it, using whichever side is tighter.
  const unit = Math.min(w, h * CHALKBOARD_ASPECT);
  const chalkWidth = Math.round(w * 0.195);
  const chalkHeight = Math.round(chalkWidth / CHALK_ASPECT);
  return {
    frame: Math.max(6, Math.round(w * CHALKBOARD_FRAME_RATIO)),
    titleTop: Math.round(h * 0.148),
    titleSize: Math.max(12, Math.round(unit * 0.067)),
    gradeCenterY: Math.round(h * 0.558),
    gradeSize: Math.max(48, Math.round(unit * 0.418)),
    chalkLeft: Math.round(w * 0.677),
    // Canva's chalk sits with its centre on the bottom rail.
    chalkTop: Math.round(h * 0.881 + (h * 0.116 - chalkHeight) / 2),
    chalkWidth,
    chalkHeight,
  };
}
